<div class="modal-body">
	<button class="close" (click)="closeAndDestroy()">
		<i class="fa-light fa-xmark"></i>
	</button>
	<div class="content">
		<div>
			<h3>service point information</h3>
			<div class="service-point-info">
				Service points are the physical locations where you can return your LINDBERG products.
			</div>
			@if (_servicePoint().length > 0) {
			<div class="service-point-info">
				The service points for your specific location are
				@for (servicePoint of _servicePoint(); track servicePoint.countryCode) {
				<div class="service-point-address" [innerHTML]="servicePoint.returnAddress.replace(/\r/g, '<br />')"></div>
				}
			</div>
			}
			@else {
			<div class="service-point-info">
				No service points found for your specific location.
			</div>
			}
		</div>
	</div>
</div>